var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKravLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 20,
    viewBox: "0 0 90 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_543_87422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9726 7.03531C57.9726 5.81063 57.7345 2.10815 51.0822 2.10815H43.2323V18.2896H49.1991V11.5361L51.8687 18.3109H58.9322L54.9663 11.0552C56.8061 10.5649 57.9726 9.29517 57.9726 7.03531ZM50.2862 8.52294H49.1173V6.26071H50.2862C51.6835 6.26071 52.2318 6.81738 52.2318 7.4546C52.2318 8.09181 51.7051 8.52294 50.2862 8.52294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4743 2.10815H35.4329L31.7653 7.99469V2.10815H25.9427V18.3109H31.7653V12.5689L32.0346 12.2444L35.5628 18.3109H41.8182L36.4959 9.66708L41.4743 2.10815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3814 2.10815L59.887 18.3109H65.8826L66.5103 14.3763H68.3622L68.9899 18.3109H75.849L70.6277 2.10815H63.379H63.3814ZM67.1789 5.78694H67.3088L67.5012 7.19166L68.1457 11.7611H66.6691L67.0515 7.17744L67.1813 5.78931L67.1789 5.78694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1385 2.10815L82.191 10.5838L81.9312 12.8508H81.7148L81.4574 10.5838L80.4642 2.10815H73.6051L78.6099 18.3109H85.4257L90 2.10815H83.1385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 17.4749H0V20H19.3506V17.4749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 0H0V2.52517H19.3506V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 3.43018H0V4.86805H19.3506V3.43018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3506 15.1794H0V16.6173H19.3506V15.1794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08321 5.7373H0V14.2982H3.08321V5.7373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15011 5.7373H4.06689V14.2982H7.15011V5.7373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2169 5.7373H8.13367V14.2982H11.2169V5.7373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2838 5.7373H12.2006V14.2982H15.2838V5.7373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3507 5.7373H16.2675V14.2982H19.3507V5.7373Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_543_87422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKravLogo);
export default __webpack_public_path__ + "static/media/krav_logo.910aca2df4ee3c9b5cfaba2ffcb5ac63.svg";
export { ForwardRef as ReactComponent };